const SITE_URL = "https://www.createprints.ai/";
const ORGANIZATION_ID = `${SITE_URL}#organization`;

export const HOMEPAGE_STRUCTURED_DATA = {
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": "Organization",
      "@id": ORGANIZATION_ID,
      name: "Create Prints",
      legalName: "Viable Digital Limited",
      url: SITE_URL,
      logo: {
        "@type": "ImageObject",
        url: `${SITE_URL}logo512.png`,
        width: 512,
        height: 512,
      },
      identifier: {
        "@type": "PropertyValue",
        propertyID: "Companies House",
        value: "13599956",
      },
      address: {
        "@type": "PostalAddress",
        streetAddress: "Office 4, 8–9 Rodney Road",
        addressLocality: "Portsmouth",
        postalCode: "PO4 8BF",
        addressCountry: "GB",
      },
      contactPoint: {
        "@type": "ContactPoint",
        contactType: "customer support",
        email: "support@createprints.ai",
        availableLanguage: "English",
      },
    },
    {
      "@type": "SoftwareApplication",
      "@id": `${SITE_URL}#application`,
      name: "Create Prints",
      description:
        "Create Prints turns images and generated artwork into physical wall prints, posters, and framed artwork.",
      url: SITE_URL,
      applicationCategory: "DesignApplication",
      operatingSystem: "Any",
      browserRequirements: "Requires a modern web browser.",
      isAccessibleForFree: true,
      publisher: { "@id": ORGANIZATION_ID },
      featureList: [
        "Create original artwork from a text description",
        "Use photos to guide artwork style and interior matching",
        "Choose print sizes, formats, frames, and mounts",
        "Order and track physical wall-art prints",
      ],
      offers: {
        "@type": "Offer",
        name: "Free monthly artwork creation credits",
        price: "0",
        priceCurrency: "GBP",
        url: `${SITE_URL}login`,
        description:
          "New accounts receive five artwork generation credits per month. Physical prints and additional credits are sold separately.",
      },
    },
  ],
};
